module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5AxIqt/tc-custom/9780765387073.jpg?1737746322476",
      "alt": "This image is the cover for the book The Forlorn Hope"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Forlorn Hope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A band of mercenaries must fight their way across a hostile planet after they’re sold out to the enemy in this classic military science fiction odyssey.")]), _c('br'), _c('br'), _vm._v("They had fought long and hard, and damn near won in spite of everything. But now the men who hired them are going to sell them to the enemy . . . and so begins a novel of adventure in which a band of Star Mercenaries is driven across the face of a planet by enemies bent on their destruction. With only the guns in their hands, this tiny band must battle ships, artillery, treachery, and the most powerful tank in the universe . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Praise for "), _c('i', [_vm._v("The Forlorn Hope")])]), _c('br'), _c('br'), _vm._v("“Vigorous and compelling. . . . A book that any Hammer’s Slammers fan will enjoy. . . . A page-turner, fast-paced and hard to put down.” —"), _c('i', [_vm._v("Reactor")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Drake\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A Tom Doherty Associates Book\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0